import 'reflect-metadata';

import { Container } from 'inversify';

import { InversifyContainer } from '../abstract/infrastructrue/Inversify.container';
import { ReactHookService } from './application/React.hook.service';
import { InternalAxiosConfigAdapter } from './infrastructrue/adapters/InternalAxiosConfig.adapter';
import { ModifiedAxiosRequestConfigAdapter } from './infrastructrue/adapters/ModifiedAxiosRequestConfig.adapter';
import { ReactHookFactory } from './infrastructrue/factories/React.hook.factory';
import { ReactHookServicePort } from './port/React.hook.service.port';

export class SharedCoreDomainContainer extends InversifyContainer {
  static create(): Container {
    return this.buildInversifyIOCContainer([
      InternalAxiosConfigAdapter,
      ReactHookService,
      ReactHookFactory,
      ReactHookServicePort,
      ModifiedAxiosRequestConfigAdapter,
    ]);
  }
}
